module.exports = __webpack_public_path__ + "static/media/logo (2).f4b23f87.png";